<template>
  <div class="card plan-card m-1">
    <div class="card-body">
      <div class="d-flex justify-content-between plan-day-header">
        <div
          class="day d-flex"
          :class="{ 'day-other-month': isCurrentMonth, 'day-current': isCurrentDay }"
        >
          <span class="number">{{ dayDate }}</span>
        </div>
      </div>
      <div class="d-flex flex-column">
        <article class="plan-day-body">
          <h6 class="plan-text-header">{{ $t("pages.planning.planning_hours") }}</h6>
          <div class="plan-text-body">
            <div v-if="issetFirstTime">{{ firstTime }}</div>
            <div v-if="issetSecondTime">{{ secondTime }}</div>
            <div v-if="!issetFirstTime && !issetSecondTime">-</div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { CalendarCell } from "@/components/calendar";
import { formatTime } from "@/utils/functions";

export default {
  props: {
    cell: {
      type: CalendarCell,
      required: true,
    },
  },
  computed: {
    dayDate() {
      return this.cell.day.getDate();
    },
    isCurrentMonth() {
      return this.cell.day.getMonth() != this.cell.month;
    },
    isCurrentDay() {
      let current = new Date();
      return (
        this.cell.day.getDate() === current.getDate() &&
        this.cell.day.getMonth() == current.getMonth()
      );
    },
    issetFirstTime() {
      return (
        this.$isset(this.cell.data.firstPartStartingTime) &&
        this.$isset(this.cell.data.firstPartEndingTime)
      );
    },
    issetSecondTime() {
      return (
        this.$isset(this.cell.data.secondPartStartingTime) &&
        this.$isset(this.cell.data.secondPartEndingTime)
      );
    },
    firstTime() {
      return this.issetFirstTime
        ? `${formatTime(this.$parseTime(this.cell.data.firstPartStartingTime))} - ${formatTime(
            this.$parseTime(this.cell.data.firstPartEndingTime)
          )}`
        : null;
    },
    secondTime() {
      return this.issetSecondTime
        ? `${formatTime(this.$parseTime(this.cell.data.secondPartStartingTime))} - ${formatTime(
            this.$parseTime(this.cell.data.secondPartEndingTime)
          )}`
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-card {
  height: 180px;
  width: 100%;
  min-width: 120px;
  max-width: 170px;
  margin: 0.35rem !important;
  border: 1px solid var(--portal-border) !important;
  border-radius: 14px !important;
  background: var(--portal-surface) !important;
  box-shadow: var(--portal-shadow-sm);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--portal-shadow);
    border-color: transparent !important;
  }

  & > .card-body {
    padding: 0 !important;
    margin: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.day {
  color: var(--portal-primary);
  background-color: var(--portal-primary-soft);
  border-radius: 0 0 12px 0;
  min-width: 46px;
  justify-content: center;
}

.day-other-month {
  color: var(--portal-text-muted);
  background-color: var(--portal-surface-muted);
}

.day-current {
  color: #fff;
  background-color: var(--portal-primary);
}

.number {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  text-align: center;
  padding: 0.7rem 0.75rem;
}

.plan-text-header {
  color: var(--portal-text-muted);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
  margin: 0 0 0.35rem;
}

.plan-text-body {
  color: var(--portal-text);
  font-size: 0.88rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
  line-height: 1.35;
}

.plan-day-body {
  margin: 0.85rem 0.85rem 0.75rem !important;
  flex: 1;
}

.plan-day-header {
  & > img {
    margin-top: 0.5rem !important;
    margin-right: 0.5rem !important;
  }
}
</style>
